var $ = require('../internals/export');

// `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/
$({ target: 'Math', stat: true }, {
  RAD_PER_DEG: 180 / Math.PI
});



//////////////////
// WEBPACK FOOTER
// ../sdk/map/node_modules/core-js/modules/esnext.math.rad-per-deg.js
// module id = 488
// module chunks = 0